import { render, staticRenderFns } from "./deal-row.vue?vue&type=template&id=4fbbd2b2"
import script from "./deal-row.vue?vue&type=script&lang=js"
export * from "./deal-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports